
export const fileToDataUrl = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target?.result as string);
        reader.onerror = () => reject(new Error('Errore nella lettura del file'));
        reader.readAsDataURL(file);
    });
};

export const processFile = async (file: File): Promise<{ image: string; type: 'image' | 'pdf'; width: number; height: number } | null> => {
    return new Promise((resolve, reject) => {
        const isImage = file.type.startsWith('image/');
        const isPdf = file.type === 'application/pdf';

        if (!isImage && !isPdf) {
            reject(new Error('Tipo di file non supportato. Usa immagini o PDF.'));
            return;
        }

        if (isImage) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new window.Image();
                img.onload = () => {
                    resolve({
                        image: e.target?.result as string,
                        type: 'image',
                        width: img.width,
                        height: img.height,
                    });
                };
                img.onerror = () => reject(new Error('Errore nel caricamento dell\'immagine'));
                img.src = e.target?.result as string;
            };
            reader.onerror = () => reject(new Error('Errore nella lettura del file'));
            reader.readAsDataURL(file);
        } else {
            // For PDF, we'll use a placeholder (in production, you'd render PDF to canvas)
            const reader = new FileReader();
            reader.onload = () => {
                // Create a placeholder image for PDF
                const canvas = document.createElement('canvas');
                canvas.width = 800;
                canvas.height = 600;
                const ctx = canvas.getContext('2d');
                if (ctx) {
                    ctx.fillStyle = '#f3f3f3';
                    ctx.fillRect(0, 0, 800, 600);
                    ctx.fillStyle = '#959595';
                    ctx.font = '40px Arial';
                    ctx.textAlign = 'center';
                    ctx.fillText('Documento PDF', 400, 280);
                    ctx.font = '20px Arial';
                    ctx.fillText(file.name, 400, 320);
                    resolve({
                        image: canvas.toDataURL('image/png'),
                        type: 'pdf',
                        width: 800,
                        height: 600,
                    });
                }
            };
            reader.onerror = () => reject(new Error('Errore nella lettura del file'));
            reader.readAsDataURL(file);
        }
    });
};
